import { useQuery, UseQueryOptions } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError, BaseResponse } from '@utils/types/shared/base.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import { AxiosError } from 'axios';
import { UserResponse } from '@utils/types/profile/user-profile';

export async function getMe(): Promise<BaseResponse<UserResponse>> {
  const { data } = await Axios.get(GET_URL().me);
  return data;
}

export function useGetMe(
  options?: UseQueryOptions<BaseResponse<UserResponse>, AxiosError<BaseError>>
) {
  return useQuery<BaseResponse<UserResponse>, AxiosError<BaseError>>(
    QueryKeys.user(),
    getMe,
    {
      useErrorBoundary: false,
      ...options
    }
  );
}
